export default __webpack_public_path__ + "1541f9e.png";